import { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import { decode } from '../../utils'

const ProtectedRoute = (props) => {

    const [isAccessible, setIsAccessible] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        checkAuthentication();
    }, [isAccessible]);

    function checkAuthentication() {
        const token = Cookies.get('token');
        if (token) {
            try {
                const decodedToken = decode(token);
                if (decodedToken) {
                    setIsAccessible(props.allowedAuthorities.some(item => decodedToken.authorities.includes(item)));
                } else {
                    navigate('/');
                }
            } catch (error) {
                console.error('Error decoding token:', error);
                setIsAccessible(false);
            }
        } else {
            navigate('/');
        }
    }

    return (
        isAccessible ? props.children : null
    );
};

export default ProtectedRoute;
